import React, { useCallback, useMemo, useState } from 'react';
import { ModalQueueContext } from './context';
export const ModalProvider = ({ children }) => {
    const [queue, updateQueue] = useState([]);
    const setOpen = useCallback((modalId, open) => {
        if (open) {
            updateQueue((oldQueue) => [...oldQueue, modalId]);
        }
        else {
            updateQueue((oldQueue) => oldQueue.filter((id) => id !== modalId));
        }
    }, []);
    const modalContextValue = useMemo(() => ({ queue, setOpen }), [queue, setOpen]);
    return (React.createElement(ModalQueueContext.Provider, { value: modalContextValue }, children));
};
//# sourceMappingURL=ModalProvider.js.map